export default __webpack_public_path__ + "static/media/Branded-lemon.6f8a17bc.png";